import React, { FunctionComponent } from 'react';
import styles from './custom-skeleton.module.scss';

interface Props {
  type?: 'text' | 'image' | 'button' | 'button-secondary';
  width?: number | string;
  height?: number | string;
  circle?: boolean;
  className?: string;
  style?: object;
  [rest: string]: unknown;
}

const getValidCSSInput = (input: string | number) => {
  switch (typeof input) {
    case 'undefined':
    case 'boolean':
      return null;
    case 'number': {
      return `${input}px`;
    }
    default: {
      const parsedInput = parseFloat(input);
      const unit = input.match(/%|em/)?.[0];
      return isNaN(parsedInput)
        ? ''
        : unit
          ? `${parsedInput}${unit}`
          : `${parsedInput}px`;
    }
  }
};

const CustomSkeleton: FunctionComponent<Props> = ({
  width,
  height,
  circle,
  type = 'text',
  className = '',
  style = {},
  ...rest
}) => {
  const isTextType = type === 'text';
  const classNames = `${styles.pulse} ${!className ? type : ''} ${isTextType ? styles.transform : ''} ${type === 'button-secondary' && !className ? styles.button : ''} ${circle ? styles.circle : ''} ${className}`;

  return (
    <span
      {...rest}
      className={classNames}
      style={{
        ...style,
        //@ts-expect-error Width processing can result in an invalid value.
        width: getValidCSSInput(width) ?? '',
        //@ts-expect-error Height processing can result in an invalid value.
        height: getValidCSSInput(height) ?? '',
        borderRadius: '4px',
      }}
    />
  );
};

export default CustomSkeleton;
